import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return <div className="min-h-[60vh] grid place-items-center" data-testid="auth-loading"><Loader2 className="w-6 h-6 animate-spin text-[var(--kc-blue)]" /></div>;
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-[60vh] grid place-items-center px-6" data-testid="access-denied">
        <div className="kc-card p-10 max-w-md text-center">
          <h1 className="text-2xl font-semibold mb-2">Access denied</h1>
          <p className="text-[#5A606A]">This area is reserved for the Kaur Cleaning team.</p>
        </div>
      </div>
    );
  }
  return children;
}
